import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import { formatCurrency } from '../utils/currencyUtils';

function CopyFutures({index, tradeasset, trade}) {
  const [loading, setLoading] = useState(false);
  const [marketPrice, setMarketPrice] = useState(trade.current_price);
  const [liqPrice, setLiqPrice] = useState(trade.liq_price);
  const [pandl, setPandl] = useState(trade.pl_roi);

  useEffect(() => {
    let isCancelled = false;
    const fetchFutures = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchpandl1: true, tradeID: trade.order_id })
      })
        .then(r => r.json())
        .then(data => {
          if (isCancelled) return;
          if (data.status === "success" && data.trade) {
            const t = data.trade;
            const nextMarket = Number(t.current_price) || 0;
            const nextLiq    = Number(t.liq_price) || 0;
            const nextPnL    = Number(t.pl_roi) || 0;
            if(pandl && pandl != "" && trade.status == "position"){
              setMarketPrice(prev => (nextMarket === prev ? prev - 0.01 : nextMarket));
              setLiqPrice(prev => (nextLiq === prev ? prev - 0.01 : nextLiq));
              setPandl(prev => (nextPnL === prev ? prev - 0.01 : nextPnL));
            }
          }
        })
        .catch(() => {});
    };
    fetchFutures();
    const interval = setInterval(fetchFutures, 5000);
    return () => {
      isCancelled = true;
      clearInterval(interval);
    };
  }, [trade.order_id]);

  const notional = Number(trade.amount) * Number(trade.leverage);
  const qty = trade.price ? (notional / Number(trade.price)) : 0;
  const qty1 = trade.price ? (Number(trade.amount) / Number(trade.price)) : 0;
  if(pandl && pandl != ""){
    var pnlPct = Number(trade.amount)? (pandl / Number(trade.amount)) * 100 : 0;
  }else{
    var pnlPct = 0;
  }

  if (!tradeasset) {
    return <div style={{ textAlign: "center", marginTop: "20%", marginBottom: "20%"}}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <>
    <tr key={index}>
        <td>{index + 1}</td>
        <td>#{trade.order_id}</td>
        <td>
          {trade.copydata && (
          <div className="mt-1 d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-circle" style={{width:'20px',height:'20px'}}>
              <img src={`/uploads/${trade.copydata.trader_photo}`} alt={trade.copydata.trader_name} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
            </div>
            <span className="fw-semibold ms-1" style={{fontSize:'14px',color:'gray'}}>{trade.copydata.trader_name}</span>
          </div>
          )}
        </td>
        <td>{trade.type}</td>
        <td><div className={`myBtn d-inline-block px-2 py-1 ${trade.side == "Long"?'bg-success':'bg-danger'}`} style={{fontSize:'12px'}}>{trade.side}</div></td>
        <td>{trade.future_type}</td>
        <td><span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span></td>
        <td className="text-nowrap">
        <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
        <span className="fw-bold ms-1">{tradeasset.symbol}/USDT</span>
        </td>
        <td>{formatCurrency(trade.price)}</td>
        <td>{formatCurrency(notional)}</td>
        <td className="text-nowrap">{qty1.toFixed(4)} {tradeasset.symbol}</td>
        <td>{marketPrice ? formatCurrency(marketPrice) : '--'}</td>
        <td>{liqPrice ? formatCurrency(liqPrice) : '--'}</td>
        <td className={pandl > 0 ? 'text-success' : pandl < 0 ? 'text-danger' : ''}>
          {pandl !== null && pandl !== undefined && pandl !== "" ? (
            <>
              <p className="mb-0 lh-1" style={{ fontSize: '12px' }}>
                {Number(pandl).toFixed(4)} USDT
              </p>
              <p className="mb-0 lh-1" style={{ fontSize: '12px' }}>
                ({pnlPct.toFixed(2)}%)
              </p>
              <p className="mb-0 lh-1" style={{ fontSize: '12px' }}>
                {formatCurrency(Number(pandl))} USD
              </p>
            </>
          ) : (
            <p className="mb-0 lh-1">--</p>
          )}
        </td>
        <td>{trade.tp && trade.sl ? `${formatCurrency(trade.tp)}/${formatCurrency(trade.sl)}` : '--'}</td>
        <td className="text-nowrap">{trade.order_time}</td>
        <td className={`${trade.status == 'closed'?'text-danger':'text-success'}`}>{trade.status.charAt(0).toUpperCase() + trade.status.slice(1)}</td>
    </tr>
    </>
  )
}

export default CopyFutures